import { CheckoutStepViewedEvent } from '@delta-defense/frontend-analytics/events/checkoutStepViewedEvent';

export class CheckoutStepCompletedEvent extends CheckoutStepViewedEvent {
	public name: string = 'Checkout Step Completed';
}
